export const RESOURCE_TYPE_PROJECT_VERSIONS = 'PROJECT_VERSIONS';
